import { JSONTree } from "react-json-tree";

export const JsonView = ({ label, value }) => {
  const theme = {
    scheme: "monokai",
    author: "wimer hazenberg (http://www.monokai.nl)",
    base00: "#fafafa",
    base01: "#383830",
    base02: "#49483e",
    base03: "#75715e",
    base04: "#a59f85",
    base05: "#f8f8f2",
    base06: "#f5f4f1",
    base07: "#f9f8f5",
    base08: "#f92672",
    base09: "#464646",
    base0A: "#f4bf75",
    base0B: "#464646",
    base0C: "#a1efe4",
    base0D: "#464646",
    base0E: "#ae81ff",
    base0F: "#cc6633",
    nestedKeyLabel: {
      fontSize: "14px",
    },
    value: {
      fontSize: "14px",
    },
  };

  return (
    <div className="my-6">
      <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize">
        {label}
      </h1>
      <div className="capitalize my-1 bg-white">
        <JSONTree theme={theme} data={value} />
      </div>
    </div>
  );
};
